import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import Panel from 'components/Panel';
import ModalHeadline from 'components/ModalHeadline';

import AuthPageWrapper from './shared/AuthPageWrapper';

function ForgotPasswordConfirmation() {
	const [t] = useTranslation();
	return (
		<AuthPageWrapper>
			<ModalHeadline title={t('forgot_pw_success_title')} />
			<Panel>
				<p>{t('forgot_pw_success_description')}</p>
			</Panel>
			<Panel align="center">
				<Button as={Link} to="login" variant="primary">
					{t('back_to_login')}
				</Button>
			</Panel>
		</AuthPageWrapper>
	);
}

export default ForgotPasswordConfirmation;
